module.exports = __webpack_public_path__ + "img/10.faa31164.jpg";